export const WHATSAPP_PRODUCTS = [
  'RECRUITMENT',
  'ENGAGEMENT',
  'LEARNING',
  'PAYROLL',
  'PERFORMANCE',
  'PERSONAS_HRIS',
] as const;

export type TWhatsappProductId = (typeof WHATSAPP_PRODUCTS)[number];

export const WHATSAPP_MANAGER_URL =
  'https://business.facebook.com/wa/manage/message-templates/';

export const WHATSAPP_TEMPLATES_PAGE_SIZES = [10, 15, 20, 25] as const;

export const SEND_TEST_TEMPLATES_PAGE_SIZE = 50;

export const SEND_TEST_MAX_RECIPIENTS = 1000;

export const SEND_TEST_SOURCE_MAX_LENGTH = 64;
